export const UID_TYPE_GIGYA = 'gigya';
export const UID_TYPE_DEVICE_ID = 'deviceid';
export const DEFAULT_HEARTBEAT_INTERVAL = 240000;
export const MAX_HEARTBEAT_INTERVAL = 899000;
